import { render, staticRenderFns } from "./gemsPromo.vue?vue&type=template&id=48d73f40&scoped=true"
import script from "./gemsPromo.vue?vue&type=script&lang=js"
export * from "./gemsPromo.vue?vue&type=script&lang=js"
import style0 from "./gemsPromo.vue?vue&type=style&index=0&id=48d73f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d73f40",
  null
  
)

export default component.exports